// FeedbackModal.tsx
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Feedback } from '@/types/feedback';

interface FeedbackModalProps {
  feedback: Feedback;
  isOpen: boolean;
  onClose: () => void;
}

export const ContentModal: React.FC<FeedbackModalProps> = ({
  feedback,
  isOpen,
  onClose,
}) => {
  const formatDate = (timestamp: number) => {
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(timestamp));
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50"
            onClick={onClose}
          />

          <motion.div
            initial={{ opacity: 0, x: '-50%', y: '-50%' }}
            animate={{ opacity: 1, x: '-50%', y: '-50%' }}
            exit={{ opacity: 0, x: '-50%', y: '-50%' }}
            className="fixed top-1/2 left-1/2 p-4 w-11/12 max-w-lg 
           bg-white dark:bg-gray-800 rounded-xl shadow-2xl z-50"
            onClick={e => e.stopPropagation()}
          >
            <div className="flex items-start space-x-4">
              <div
                className="w-12 h-12 rounded-full flex items-center justify-center 
                         text-white text-lg font-bold shrink-0"
                style={{ backgroundColor: feedback.avatarColor }}
              >
                {feedback.nickname.charAt(0).toUpperCase()}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex justify-between items-start">
                  <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                    {feedback.nickname}
                  </h3>
                  {feedback.location && (
                    <span className="text-sm text-gray-500 dark:text-gray-400">
                      📍 {feedback.location}
                    </span>
                  )}
                </div>
                <div className="text-sm text-gray-600 dark:text-gray-400">
                  <span>{feedback.position}</span>
                  {feedback.company && (
                    <>
                      <span> @ </span>
                      <span>{feedback.company}</span>
                    </>
                  )}
                </div>
                <p className="text-sm text-gray-500 dark:text-gray-500">
                  {formatDate(feedback.createdAt)}
                </p>
              </div>

              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 
                         dark:hover:text-gray-300 ml-2"
              >
                ✕
              </button>
            </div>

            <div className="mt-4 text-gray-700 dark:text-gray-300">
              {feedback.text}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default ContentModal;
